import { gql } from "@apollo/client";
import WagerTypesFragments from "../fragments/WagerTypesFragment";
import TimeAndStatusFragments from "../fragments/TimeAndStatusFragment";
import RaceDetailsFragments from "../fragments/RaceDetailsFragment";
import BettingInterestsFragments from "../fragments/BettingInterestsFragment";
import ResultsFragments from "../fragments/ResultsFragment";
import PromosFragments from "../fragments/PromosFragment";
import ProbablesFragment from "../fragments/ProbablesFragment";

export const GET_RACE_PROGRAM_SUBSCRIPTION = gql`
  subscription raceUpdateByTvgRaceIds(
    $wagerProfile: String!
    $product: String
    $brand: String
    $tvgRaceIds: [Long!]
  ) {
    raceUpdateByTvgRaceIds(
      profile: $wagerProfile
      tvgRaceIds: $tvgRaceIds
      brand: $brand
      product: $product
    ) {
      id
      tvgRaceId
      ...RaceDetails
      ...TimeAndStatus
      ...WagerTypes
      ...BettingInterests
      ...Results
      ...Promos
      ...Probables
    }
  }
  ${WagerTypesFragments.entry}
  ${TimeAndStatusFragments.entry}
  ${RaceDetailsFragments.entry}
  ${BettingInterestsFragments.entry}
  ${ResultsFragments.entry}
  ${PromosFragments.entry}
  ${ProbablesFragment.entry}
`;
